import type { FaireProductEntity } from "../../entity_types/product";

export const p_hhqgwwpjt4: FaireProductEntity = {
  token: "p_hhqgwwpjt4",
  type: "product",
  name: "Blush Sequin Wing Beaded Statement Earrings",
  brandToken: "b_vjqfbthsp3",
  brandName: "Brookhaven Baubles",
  imageUrl: "https://cdn.faire.com/fastly/bae9b442fafe6895c6a55b12235b8143a6b0dc38f2309f32e87cc299772de1eb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d4162c908a932a374e7c2f682c7509c9ac6ebd4eb4807638ee6c660b76318631.jpeg",
    "https://cdn.faire.com/fastly/062db800885636ed2d943bf576535f6a7e7c7d0189a77ab6dd5afafa2581a340.jpeg",
    "https://cdn.faire.com/fastly/fd9c807cfe122edb9f6c2639d98ba00f6efb944315e57f5e79cb9343f53af977.jpeg",
    "https://cdn.faire.com/fastly/08b4b991b3b7c32d26f1687abdcf2bb0af176899eca2ddf498a8d3ecbbb01ba1.jpeg",
    "https://cdn.faire.com/fastly/4fea14f135ad229d877f257a545af6cc1d75942f0788b6fc16df3d0a35793bfb.jpeg",
    "https://cdn.faire.com/fastly/d6934143cd10088029daeb09bd1731aef55d8088de22496bdf7e6e6996d25b2c.jpeg",
    "https://cdn.faire.com/fastly/8a694590f6e570954cf515b8acd566dbb41e00510428347810ddea4dc109dda8.jpeg"
  ],
  priceDollars: 14,
  description: "Blush Sequin Wing Beaded Earrings - Brookhaven Baubles - Southern Statement Jewelry - Beaded Statement Earrings\n\nBlush Wing Beaded Earrings - Southern Statement Jewelry - Sequin Statement Earrings \n\nThese lightweight earrings are made from acrylic seed beads that you will practically forget you are wearing them.\n\nOur earrings are the perfect statement for any occasion or outfit! Perfect for every occasion, from casual days to special events like weddings and birthdays. Get a pair for yourself, your bestie, or as a gift!\n\nAll posts are lead and nickel-free and very lightweight for easy everyday wear.\n\n\n\nAll images are copyrighted by Brookhaven Baubles. All rights reserved.",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T16:32:09.751Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
